module.exports = __webpack_public_path__ + "img/light-mud-decal-24.cb829a10.png";